module.exports = __webpack_public_path__ + "static/media/Payload.de1be54a.svg";